import { AlternativeRegistrationModalProvider } from '@exam-center/alternative-registration';
import { APP_PERMISSIONS } from '@exam-center/permission';
import {
  DipChipDeepLinkButton,
  RegistrationExamineesList,
  RegistrationExamineesSearchBox,
} from '@exam-center/proctoring-registrations';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function RegistrationsPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.PROCTORING.REGISTRATION.VIEW}>
      <AlternativeRegistrationModalProvider>
        <Flex sx={{ flexDirection: 'column', height: '100%', overflow: 'auto' }}>
          <Flex
            sx={(theme) => ({
              flex: 1,
              p: theme.spacing(0),
              py: theme.spacing(4),
              flexDirection: 'column',
              gap: theme.spacing(6),
              [theme.breakpoints.up('tablet')]: {
                p: theme.spacing(6),
                py: theme.spacing(6),
              },
            })}
          >
            <PaperSection title='การลงทะเบียนผู้เข้าสอบ' endAdornment={<DipChipDeepLinkButton />}>
              <Flex
                sx={(theme) => ({
                  flexDirection: 'column',
                  gap: theme.spacing(6),
                  p: theme.spacing(6),
                })}
              >
                <RegistrationExamineesSearchBox />
                <RegistrationExamineesList />
              </Flex>
            </PaperSection>
          </Flex>
        </Flex>
      </AlternativeRegistrationModalProvider>
    </PermissionGuard>
  );
}
